import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFnsV3';
import { StaticDatePicker } from '@mui/x-date-pickers';
import Typography from '@mui/material/Typography';
import Popover from '@mui/material/Popover';
import OutlinedInput from '@mui/material/OutlinedInput';
import InputAdornment from '@mui/material/InputAdornment';
import IconButton from '@mui/material/IconButton';
import ClickAwayListener from '@mui/material/ClickAwayListener';
import Popper from '@mui/material/Popper';
import { DateRangeIcon, ExpandMoreIcon } from '../customStyles/images';
import { PopBox, ArrowRightUpOut, ArrowRightUpIn } from '../customStyles/box';

import { sub } from 'date-fns'
import { zhTW } from "date-fns/locale";
import { formatDate, yesterday, last7day } from '../../utils/date';

import { DateButton } from './dateStyle';

import {
  TextField,
  Box,
  Divider,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  Stack,
  Button,
} from '@mui/material';

import theme from '../../theme';

const RangeShortcut = {
  today: 'TODAY',
  yesterday: 'YESTERDAY',
  last7Days: 'LAST_7_DAYS',
  last14Days: 'LAST_14_DAYS',
  last30Days: 'LAST_30_DAYS',
  last90Days: 'LAST_90_DAYS',
  reset: "RESET"
};

const rangeShortcuts = [
  {
    range: RangeShortcut.today,
    label: '今天',
  },
  {
    range: RangeShortcut.last7Days,
    label: '過去7天',
  },
  {
    range: RangeShortcut.last30Days,
    label: '過去30天',
  },
  {
    range: RangeShortcut.last90Days,
    label: '過去90天',
  },
  // {
  //   range: RangeShortcut.reset,
  //   label: '重設',
  // }
];

const DateRange = (props) => {
  const {
    type,
    dateRange,
    setDateRange,
    anchorHorizontal,
  } = props;

  const [anchorEl, setAnchorEl] = React.useState(null);
  const [origiDate, setOrigiDate] = useState({
    startDate: last7day,
    endDate: yesterday
  });

  const handleRangeClick = (setOrigiDate) => (range) => {
    switch (range) {
      case RangeShortcut.today:
        setOrigiDate({
          startDate: sub(new Date(), { days: 0 }),
          endDate: sub(new Date(), { days: 0 })
        })
        break;
      case RangeShortcut.yesterday:
        setOrigiDate({
          startDate: sub(new Date(), { days: 3 }),
          endDate: sub(new Date(), { days: 1 })
        })
        break;
      case RangeShortcut.last7Days:
        setOrigiDate({
          startDate: sub(new Date(), { days: 7 }),
          endDate: sub(new Date(), { days: 1 })
        })
        break;
      case RangeShortcut.last14Days:
        setOrigiDate({
          startDate: sub(new Date(), { days: 14 }),
          endDate: sub(new Date(), { days: 1 })
        })
        break;
      case RangeShortcut.last30Days:
        setOrigiDate({
          startDate: sub(new Date(), { days: 30 }),
          endDate: sub(new Date(), { days: 1 })
        })
        break;
      case RangeShortcut.last90Days:
        setOrigiDate({
          startDate: sub(new Date(), { days: 90 }),
          endDate: sub(new Date(), { days: 1 })
        })
        break;
      case RangeShortcut.reset:
        setOrigiDate({
          startDate: null,
          endDate: null
        })
        break;
      default:
        break;
    }
  };

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handlePopClose = () => {
    setAnchorEl(null);
  };

  const handleDateChange = (target, value) => {
    setOrigiDate(prev => ({
      ...prev,
      [target]: value
    }))
  }

  const handleDateSubmit = () => {
    setDateRange({
      startDate: origiDate.startDate,
      endDate: origiDate.endDate
    })
    setAnchorEl(null);
  }

  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;
  const currentStartDate = dateRange.startDate === null ? "0000/00/00" : formatDate(dateRange.startDate);
  const currentEndDate = dateRange.endDate === null ? "0000/00/00" : formatDate(dateRange.endDate);

  return (
    <>
      <DateButton
        aria-describedby={id}
        onClick={handleClick}
        type={type}
      >
        <DateRangeIcon />
        <Typography ml={1} mr={1} sx={{ fontSize: '0.875rem' }}>{currentStartDate + '　-　' + currentEndDate}</Typography>
        {/* <OutlinedInput
            // error={downloadInputErrorMsg.dateRange}
            name="startReportDate"
            placeholder="yyyy/mm/dd"
            value={dateRange.startDate === null ? "" : formatDate(dateRange.startDate)}
          />

          <Typography ml={1} mr={1}> - </Typography>

          <OutlinedInput
            // error={downloadInputErrorMsg.dateRange}
            name="endReportDate"
            placeholder="yyyy/mm/dd"
            value={dateRange.endDate === null ? "" : formatDate(dateRange.endDate)}
          /> */}
        <ExpandMoreIcon />
      </DateButton>

      <Popper
        id={id}
        open={open}
        anchorEl={anchorEl}
        placement='bottom-end'
        style={{
          zIndex: 1000,
        }}
      >
        <ClickAwayListener onClickAway={handlePopClose}>
          <Box>
            <Stack
              variant="end-center"
              sx={{
                position: 'relative',
                top: '2px',
                right: { md: '1000px', lg: '90px' },
              }}>
              <ArrowRightUpIn />
              <ArrowRightUpOut />
            </Stack>

            <PopBox sx={{ marginTop: '16px' }}>
              <Box
                sx={{
                  display: 'flex',
                }}
              >
                {/* <Box ml={2} display="flex" gap={2}>
                  <div>
                    <List>
                      {rangeShortcuts.map(({ range, label }) => (
                        <ListItem key={range} disablePadding>
                          <ListItemButton onClick={() => handleRangeClick(setOrigiDate)(range)}>
                            <ListItemText primary={label} />
                          </ListItemButton>
                        </ListItem>
                      ))}
                    </List>
                  </div>
                  <Divider orientation="vertical" />
                </Box> */}

                <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={zhTW}>
                  <Box
                    sx={{
                      borderRight: `1px solid ${theme.palette.grey.w200}`,
                      textAlign: 'center',
                      padding: '18px 0 0',
                    }}
                  >
                    <Typography variant='h6'>開始日期</Typography>
                    <StaticDatePicker
                      displayStaticWrapperAs="desktop"
                      openTo="day"
                      value={origiDate.startDate}
                      maxDate={sub(new Date(), { days: 0 })}
                      reduceAnimations={false}
                      onChange={(value) => {
                        handleDateChange('startDate', value);
                      }}
                      renderInput={(params) => <TextField {...params} />}
                    />
                  </Box>
                  <Box
                    sx={{
                      textAlign: 'center',
                      padding: '18px 0 0',
                    }}
                  >
                    <Typography variant='h6'>結束日期</Typography>
                    <StaticDatePicker
                      displayStaticWrapperAs="desktop"
                      openTo="day"
                      value={origiDate.endDate}
                      maxDate={sub(new Date(), { days: 0 })}
                      reduceAnimations={false}
                      onChange={(value) => {
                        handleDateChange('endDate', value);
                      }}
                      renderInput={(params) => <TextField {...params} />}
                    />
                  </Box>
                </LocalizationProvider>
              </Box>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "end",
                  mb: "8px",
                  mr: "20px"
                }}>
                <Button
                  variant="text-cancel"
                  onClick={handlePopClose}
                >
                  取消
                </Button>
                <Button
                  variant="contained"
                  onClick={handleDateSubmit}
                >
                  套用
                </Button>

              </Box>
            </PopBox>
          </Box>
        </ClickAwayListener>
      </Popper>
    </>
  );
}

export default DateRange;
